module.exports = __webpack_public_path__ + "img/xw.c9d0fc3f.jpg";